<template>
  <div class="error">
    <h4>阀门异常列表</h4>
    <div>
      <div class="item" v-for="item in list" :key="item.id">
        <span>{{ item.name }}</span>
        <span>{{ item.deviceNo }}</span>
        <span>端口:{{ item.port }}</span>
        <span class="errmsg">{{ item.errmsg }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      list: [
        {
          name: "E1#_1",
          errmsg: "打开超时",
          deviceNo: 10000024,
          port: 1
        },
        {
          name: "E1#_2",
          errmsg: "打开超时",
          deviceNo: 10000024,
          port: 2
        },
        {
          name: "E2#_1",
          errmsg: "打开超时",
          deviceNo: 10000024,
          port: 1
        }
      ],
      index: 1
    };
  },

  mounted() {
    this.index = [1, 2];
    console.log("this.index2:", this.index?.length);
    this.index = 3;
    console.log("this.index3:", this.index);
  }
};
</script>

<style lang="scss" scoped>
.error {
  height: 100%;
  background: #ffffff;
  font-size: 16px;
  padding: 10px;

  .item {
    display: flex;
    justify-content: space-between;
    height: 40px;
    line-height: 40px;
  }

  .errmsg {
    color: #dc3c3c;
  }
}
</style>
